import React from "react";
import { BrowserRouter } from "react-router-dom";

import AppRoot from "./AppRoot";
import { AuthProvider } from "../../provider/AuthProvider";
import { UserProvider } from "../../provider/UserProvider";
import { ThemeProvider } from "@mui/material/styles";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { CssBaseline } from "@mui/material";
import { theme } from "../../theme";

export default function App(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <StyledThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <UserProvider>
            <BrowserRouter>
              <AppRoot />
            </BrowserRouter>
          </UserProvider>
        </AuthProvider>
      </StyledThemeProvider>
    </ThemeProvider>
  );
}
